import {
  CONFLICT,
  DUPLICATE_CUSTOM_ROLE_MESSAGE,
  SOMETHING_WENT_WRONG_MESSAGE,
} from '../../../../utils/constants';

export type RoleImportStatus = 'created' | 'updated' | 'failed';

export type RoleImportResult = {
  roleName: string;
  roleUuid: string;
  status: RoleImportStatus;
  message: string;
};

export type CustomRolesImportSummary = {
  results: RoleImportResult[];
  created: number;
  updated: number;
  failed: number;
};

export const getImportErrorMessage = (error: unknown): string => {
  const graphQLError = (error as any)?.graphQLErrors?.[0];

  if (graphQLError?.validationErrors?.status === CONFLICT) {
    return DUPLICATE_CUSTOM_ROLE_MESSAGE;
  }

  if (graphQLError?.message) {
    return graphQLError.message;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return SOMETHING_WENT_WRONG_MESSAGE;
};

export const buildImportSummary = (
  results: RoleImportResult[],
): CustomRolesImportSummary => ({
  results,
  created: results.filter((result) => result.status === 'created').length,
  updated: results.filter((result) => result.status === 'updated').length,
  failed: results.filter((result) => result.status === 'failed').length,
});

export const formatImportSummaryTitle = ({
  created,
  updated,
  failed,
}: Pick<CustomRolesImportSummary, 'created' | 'updated' | 'failed'>): string =>
  `${created} created, ${updated} updated, ${failed} failed`;
